/* eslint-disable @typescript-eslint/no-explicit-any */
import { AfterViewInit, ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BigFormService } from '@flexus/core';
import { TabsData } from '@flexus/ui-elements';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'flexus-customer-details',
	templateUrl: './customer-details.component.html',
	styleUrls: ['./customer-details.component.scss']
})
export class CustomerDetailsComponent implements OnInit, AfterViewInit {
	client: string;
	provinceList: any[] = [];
	@Input() commsOptions: any[] = [];
	currentTab$: Observable<string> = of('house_estate');

	// Configuration object defining which panels/fields are visible per client
	private readonly fieldConfig: { [key: string]: any } = {
		multichoice: {
			showCustomerDetails: true,
			showContactDetails: true,
			showAddressDetails: true,
			showClarityCustomerNumber: true,
			showComplex: true
		},
		pgg: {
			showCustomerDetails: true,
			showContactDetails: true,
			showAddressDetails: true,
			showClarityCustomerNumber: false,
			showComplex: true
		},
		pinggo: {
			showCustomerDetails: true,
			showContactDetails: true,
			showAddressDetails: true,
			showClarityCustomerNumber: false,
			showComplex: true
		}
	};

	constructor(public _store: Store<any>, public bf: BigFormService, private cd: ChangeDetectorRef, @Inject('environment') private environment: any) {
		this.client = this.environment.client;
		this.bf.bigForm.addControl('address_type', new UntypedFormControl('house_estate'));
		
		const addressTypeControl = this.bf.bigForm.get('address_type');
		if(addressTypeControl) {
			addressTypeControl.valueChanges
			  .pipe(
				tap((addressType) => {
				  const insuredAddress = this.bf.bigForm.get('insured_address');
				  if (addressType === 'house_estate' && insuredAddress) {
					insuredAddress.patchValue({
					  complex_unit_number: '',
					  complex_block: '',
					});
				  }
				}),
				takeUntilDestroyed()
			  )
			  .subscribe();
			}
	}

	get isMultichoice(): boolean {
		return this.client === 'multichoice';
	}

	get isPinggo(): boolean {
		return this.client === 'pgg' || this.client === 'pinggo';
	}

	// Getters for field visibility
	get showCustomerDetails(): boolean {
		return this.fieldConfig[this.client]?.showCustomerDetails ?? false;
	}

	get showContactDetails(): boolean {
		return this.fieldConfig[this.client]?.showContactDetails ?? false;
	}

	get showAddressDetails(): boolean {
		return this.fieldConfig[this.client]?.showAddressDetails ?? false;
	}

	get showClarityCustomerNumber(): boolean {
		return this.fieldConfig[this.client]?.showClarityCustomerNumber ?? false;
	}

	get showComplex(): boolean {
		return this.fieldConfig[this.client]?.showComplex ?? false;
	}

	tabs: TabsData[] = [
		{
		  display: 'House/Estate',
		  targetId: 'house_estate',
		  show: true,
		},
		{
		  display: 'Flat/Office',
		  targetId: 'flat_office',
		  show: true,
		},
	  ];

	ngOnInit(): void {
		const provinceList = this.bf?.storeObject?.selectedContext?.provinceList;
		this.provinceList = provinceList.map(province => ({ display: province?.name, value: province?.name, id: province?.id }));
		
		// Ensure client_details FormGroup has all required controls
		const clientDetails = this.bf.bigForm.get('client_details');
		if (clientDetails instanceof UntypedFormGroup) {
			if (!clientDetails.get('customer_reference')) {
				clientDetails.addControl('customer_reference', new UntypedFormControl(''));
			}
			if (!clientDetails.get('sales_order_number')) {
				clientDetails.addControl('sales_order_number', new UntypedFormControl(''));
			}
		}
		
		// Ensure insured_address FormGroup has all required controls
		const insuredAddress = this.bf.bigForm.get('insured_address');
		if (insuredAddress instanceof UntypedFormGroup) {
			if (!insuredAddress.get('province')) {
				insuredAddress.addControl('province', new UntypedFormControl(''));
			}
			if (!insuredAddress.get('postal_code')) {
				insuredAddress.addControl('postal_code', new UntypedFormControl(''));
			}
			if (!insuredAddress.get('complex_block')) {
				insuredAddress.addControl('complex_block', new UntypedFormControl(''));
			}
		}
	}

	setArea(event: string): void {
		const area = this.provinceList.find(province => province?.value === event)?.id;
		const areaControl = this.bf.bigForm.get('area_code');
		if (areaControl) {
			areaControl.patchValue(area);
		}
	}

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.cd.detectChanges();
		}, 2000);
	}

	handleTab(tabInfo) {
		this.bf.bigForm.get('address_type')?.setValue(tabInfo.target);
		this.currentTab$ = of(tabInfo.target);
	  }
}
